module.exports = __webpack_public_path__ + "static/civilrights-9eacd3059880f52f83eb31b6ed52bd10.png";